import { useState } from "react";
import {
  getEvaluationPrompt,
  buildEvaluationUserPrompt,
} from "@offsite/shared";
import { useOffsiteConfig } from "@/engine/app/offsite-context";

const SAMPLE_FIELDS = {
  was: "<eure Anforderung — Feld 1>",
  fuerWen: "<eure Zielgruppe — Feld 2>",
  problem: "<euer Problem — Feld 3>",
  anforderungen: "<funktionale Anforderungen — Feld 4>",
  einschraenkungen: "<Leitplanken — Feld 5>",
  beispiel: "<Anwendungsfall — Feld 6>",
};

const SAMPLE_TEAM_NAME = "<euer Teamname>";
const SAMPLE_TOPIC_TITLE = "<das gewählte Thema>";
const MODEL_ID = "claude-opus-4-7";

interface Props {
  /** "compact" = nur kompakter Body + Toggle; "full" = direkt sichtbar. */
  variant?: "compact" | "full";
  /** Optional dunkler Hintergrund für Presenter-Overlay. */
  onDark?: boolean;
}

export function EvalTransparencyPanel({ variant = "compact", onDark = false }: Props) {
  const [open, setOpen] = useState(variant === "full");
  const { ai } = useOffsiteConfig();
  const userPrompt = buildEvaluationUserPrompt(
    SAMPLE_TOPIC_TITLE,
    SAMPLE_TEAM_NAME,
    SAMPLE_FIELDS,
  );
  const cls = onDark ? "eval-transparency on-dark" : "eval-transparency";

  const httpBody = {
    model: MODEL_ID,
    max_tokens: 1024,
    system: getEvaluationPrompt(ai.evalPromptKey),
    messages: [{ role: "user", content: userPrompt }],
  };

  return (
    <div className={cls}>
      <header className="eval-transparency-head">
        <div className="deck-eyebrow">Was die KI gerade tut</div>
        <h3>Echter HTTP-Request an Anthropic</h3>
        <p className="eval-transparency-sub">
          Genau diesen Body schickt die Lambda pro Team an die Anthropic-API.
        </p>
      </header>

      <div className="eval-transparency-http">
        <div className="prompt-block">
          <div className="prompt-label">Endpoint</div>
          <pre>POST https://api.anthropic.com/v1/messages</pre>
        </div>
        <div className="prompt-block">
          <div className="prompt-label">Headers</div>
          <pre>{`x-api-key: <hidden>
anthropic-version: 2023-06-01
content-type: application/json`}</pre>
        </div>
        <div className="prompt-block">
          <div className="prompt-label">Modell</div>
          <p style={{ margin: 0 }}>
            <code>{MODEL_ID}</code> · direkter Anthropic API-Aufruf
            <br />
            <small>
              Wird in der Lambda über die ENV <code>EVALUATION_MODEL_ID</code>{" "}
              überschrieben.
            </small>
          </p>
        </div>
      </div>

      <button
        type="button"
        className="eval-transparency-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        {open ? "▴ Wortwörtlichen Body verbergen" : "▾ Wortwörtlichen Body anzeigen"}
      </button>

      {open && (
        <div className="eval-transparency-prompts">
          <div className="prompt-block">
            <div className="prompt-label">Body (JSON)</div>
            <pre>{JSON.stringify(httpBody, null, 2)}</pre>
          </div>
        </div>
      )}
    </div>
  );
}
